import cards from '../../assets/images/newui/cards.png'
import DisclaimerSection from 'components/DisclaimerSection/DisclaimerSection';
import SellerStripeFormHOC from './SellerStripeFormHOC'
import { CardExpiryElement, CardCvcElement, CardNumberElement } from '@stripe/react-stripe-js';
import React, { Component } from 'react';
import arrow from '../../assets/images/newui/sellersignup/arrow-grey.svg'
import './SellerStripeForm.less'

class SellerStripeFormUpdated extends Component {
    render() {
        const { changeHandler } = this.props;
        return <div className="stripe-form-container updated">
            <img src={arrow} />
            <div className="stripe-form-updated-header">
                Payment Info
                <div className='cards-img'><img src={cards} /></div>
            </div>
            <div className="stripe-form-updated">

                <div className="stripe-form-updated-item">
                    <div className='field card-number-field'>
                        <label>
                            Credit Card Number
                        </label>
                        <CardNumberElement onChange={changeHandler} options={{ placeholder: '(0000 0000 0000 0000)' }} />
                        <div className='required'>*</div>
                    </div>
                </div>
                <div className="stripe-form-updated-item half left">
                    <div className='field'>
                        <label>
                            Card Expiry
                        </label>
                        <CardExpiryElement onChange={changeHandler} />
                        <div className='required'>*</div>
                    </div>
                </div>
                <div className="stripe-form-updated-item half right">
                    <div className='field'>
                        <label>
                            CVC
                        </label>
                        <CardCvcElement onChange={changeHandler} />
                        <div className='required'>*</div>
                    </div>
                </div>
                <div className='stripe-form-updated-msg'>
                    <img src='https://com-syndafy-dealgrace-static.s3.us-east-2.amazonaws.com/checkmark-green_1gmhgfx4krkwr9sn_.svg' />
                    <div className='stripe-form-updated-msg-content'>
                        <span className='emphasis'>No</span> Contract, <span className='emphasis'>No</span> Commitment, <span className='emphasis'>Cancel</span> Anytime.
                    </div>
                </div>
                {window.innerWidth > 1200 ? <DisclaimerSection isTrialPlan={this.props.plan.trialDays} planPrice={this.props.plan.price} buttonText={this.props.plan.trialDays ? 'Start Trial' : 'GO'} /> : ''}
            </div>
        </div>
    }
}

export default SellerStripeFormHOC(SellerStripeFormUpdated);